const Input = ({ className = "", valid = true, ...rest }) => {
  return (
    <input
      className={`px-3 py-[0.3rem] rounded-xl appearance-none w-full
             bg-white/55 dark:bg-white/5
             border border-white/60 dark:border-white/10
             backdrop-blur-xl backdrop-saturate-150
             shadow-[inset_0_1px_0_rgba(255,255,255,0.6)] dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]
             text-gray-800 dark:text-gray-200
             placeholder-opacity-30 placeholder:text-sm
             transition-all duration-200
             disabled:cursor-not-allowed
             focus:bg-white/80 dark:focus:bg-white/10
             focus:ring-4
             ${
               valid
                 ? "focus:border-sky-500/60 dark:focus:border-sky-400/50 focus:ring-sky-500/15 dark:focus:ring-sky-400/15"
                 : "border-red-500/70 dark:border-red-500/60 focus:ring-red-500/15 focus:border-red-500/70"
             }
             ${className}
             `}
      {...rest}
    />
  );
};

export default Input;
